import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LazyLoad from '../lazyload';
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
var fontWeight = {
  fontWeight: 900,
  REGULAR: 'normal',
  SEMIBLOD: 'bold'
};
var cls = 'combination';

var Combination = function Combination(_ref) {
  var combination = _ref.combination,
      onClick = _ref.onClick,
      pid = _ref.pid;

  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

  var _combination$card = combination.card,
      card = _combination$card === void 0 ? {} : _combination$card,
      wdId = combination.wdId;

  var _useConfig = useConfig(),
      createNamespace = _useConfig.createNamespace,
      prefixCls = _useConfig.prefixCls;

  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls));

  var handleCombinationClick = function handleCombinationClick() {
    onClick === null || onClick === void 0 ? void 0 : onClick(wdId, card === null || card === void 0 ? void 0 : card.deeplink);
  };

  return _jsxs("div", Object.assign({
    className: classes,
    onClick: handleCombinationClick,
    "data-productid": wdId,
    "data-pid": pid,
    "data-id": wdId
  }, {
    children: [_jsxs("div", Object.assign({
      className: classes + "-header"
    }, {
      children: [_jsx("div", {
        className: "title-img",
        style: {
          backgroundImage: "url(" + ((_c = (_b = (_a = card === null || card === void 0 ? void 0 : card.title) === null || _a === void 0 ? void 0 : _a.badge) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.url) + ")"
        }
      }), _jsxs("div", Object.assign({
        className: cls + "-info"
      }, {
        children: [_jsx("div", Object.assign({
          className: cls + "-name"
        }, {
          children: (_e = (_d = card === null || card === void 0 ? void 0 : card.title) === null || _d === void 0 ? void 0 : _d.texts) === null || _e === void 0 ? void 0 : _e.map(function (item, index) {
            return _jsx("span", Object.assign({
              style: {
                color: "#" + item.color,
                fontWeight: fontWeight[item.fontWeight] || "blod"
              }
            }, {
              children: item.text
            }), index + "_" + item.tex);
          })
        })), _jsx("div", Object.assign({
          className: cls + "-tip"
        }, {
          children: (_g = (_f = card === null || card === void 0 ? void 0 : card.subTitle) === null || _f === void 0 ? void 0 : _f.texts) === null || _g === void 0 ? void 0 : _g.map(function (item, index) {
            return _jsx("span", Object.assign({
              style: {
                color: "#" + item.color
              }
            }, {
              children: item.text
            }), index + "_" + item.tex);
          })
        }))]
      })), _jsx("button", Object.assign({
        className: cls + "-btn"
      }, {
        children: (_j = (_h = card === null || card === void 0 ? void 0 : card.title) === null || _h === void 0 ? void 0 : _h.linkButton) === null || _j === void 0 ? void 0 : _j.title
      }))]
    })), _jsx("ul", Object.assign({
      className: cls + "-product-list"
    }, {
      children: (_k = card === null || card === void 0 ? void 0 : card.items) === null || _k === void 0 ? void 0 : _k.map(function (item, index) {
        return _jsx("li", {
          children: _jsx(LazyLoad, {
            children: _jsx("img", {
              src: item === null || item === void 0 ? void 0 : item.image.url
            })
          })
        }, index + "_" + (item === null || item === void 0 ? void 0 : item.image.url));
      })
    })), _jsx("div", Object.assign({
      className: cls + "-footer"
    }, {
      children: (_m = (_l = card === null || card === void 0 ? void 0 : card.footer) === null || _l === void 0 ? void 0 : _l.texts) === null || _m === void 0 ? void 0 : _m.map(function (item, index) {
        return _jsx("span", Object.assign({
          style: {
            color: "#" + item.color
          }
        }, {
          children: item.text
        }), index + "_" + item.text);
      })
    }))]
  }));
};

Combination.displayName = 'Combination';
export default Combination;